import { create } from "zustand";

import { TOrganization } from "@type/api/corporation/types";

type TOrganizationStore = {
  selectedOrganization?: Partial<TOrganization>;
  onSetSelectedOrganization: (
    selectedOrganization?: Partial<TOrganization>
  ) => void;
};

export const useOrganizationStore = create<TOrganizationStore>((set) => ({
  selectedOrganization: undefined,
  onSetSelectedOrganization: (selectedOrganization) => {
    set({ selectedOrganization });
  },
}));
